export const EMAIL = "email";
export const CELLPHONE = "cellphone";
export const PHONE = "phone";
export const INPUT = "input";
export const RFH_FORM_ONCHANGE = "onChange";
export const STRING = "string";
export const COUNTRY_CODE = "+1";
export const FIRST_NAME = "firstName";
export const LAST_NAME = "lastName";
export const GARAGE_ADDRESS = "garageAddress";
export const FORM_SUBMISSION_FAILED = "Form submission failed";
export const SELECT = "select";
export const RADIO = "radio";
export const DATE_PICKER = "datePicker";
export const CELL_PHONE = "cellPhone";
export const COMPANY_NAME = "companyName";
export const FLEET_NAME = "fleet_name";
export const ADDRESS_LINE_1 = "addressLine1";
export const ADDRESS_LINE_2 = "addressLine2";
export const CITY = "city";
export const STATE = "state";
export const ZIP = "zip";

export const VEHICLE_FORM_FIELDS = {
  licensePlateNumber: "licensePlateNumber",
  state: "state",
  expiryDate: "expiryDate",
  lastMaintenanceService: "lastMaintenanceService",
  driver: "driver",
  vin: "vin",
  department: "department",
};
